export default String.raw`
$(document).ready(function () {
    widget1.init();
});

const widget1 = (function () {
    const init = function() {
        events();
    }

    const buttons = $('.widget-js').find('[aria-expanded]');

    const events = function() {
        const closeWidget = () => {
            $('.widget__close-js').parent().css('visibility', 'hidden');
            $('.widget__close-js').css("visibility", 'hidden');
            const widget = $('.widget-js');
            widget.removeClass('clicked');
            buttons.attr('aria-expanded', 'false');
            $('body').focus();
        }

        $('.widget__close-js').on('click', () => {
            closeWidget();
        });

        // Escape button closes widget
        $('.widget-js').on('keydown', (e) => {
            const widget = $('.widget-js');
            const button = $('.widget-js [role="button"]');
            const width = $(window).width();

            if (e.key === 'Escape') {
                widget.removeClass('clicked');
                buttons.attr('aria-expanded', 'false');
                button.focus();

                if (width <=  768) {
                    closeWidget();
                }
            }

            let firstFocusableElement;
            const lastFocusableElement = widget.find('a')[0];
            if (width <=  768) {
                firstFocusableElement = widget.find('.widget__close-js')[0];
            } else {
                firstFocusableElement = button[0];
            }

            if (e.currentTarget.classList.contains('clicked') || width <=  768) {
                if (lastFocusableElement === document.activeElement && !e.shiftKey && e.key === 'Tab') {
                    e.preventDefault();
                    firstFocusableElement.focus();
                } else if (firstFocusableElement === document.activeElement && e.shiftKey && e.key === 'Tab') {
                    e.preventDefault();
                    lastFocusableElement.focus();
                } else {
                    return;
                }
            }
        });
        
        $(window).on('load resize', () => {
            const widget = $('.widget-js');
            const width = $(window).width();
            if (width <=  768) {
                widget.removeClass('clicked');
                const timeOut = setTimeout(() => {
                    widget.find('.widget__close-js').focus();
                    clearTimeout(timeOut);
                });
                widget.find('a').attr('tabindex', '0');
                buttons.attr('aria-expanded', 'true');
            } else {
                widget.find('a').attr('tabindex', '-1');
                buttons.attr('aria-expanded', 'false');
            }
        });

        $('.widget-js [role="button"]').on('click', () => {
            const width = $(window).width();
            if (width >  768) {
                const widget = $('.widget-js');
                if (!widget.hasClass('hover')) {

                    if (widget.hasClass('clicked')) {
                        widget.removeClass('clicked');
                        widget.find('a').attr('tabindex', '-1');
                        buttons.attr('aria-expanded', 'false');
                    }
                    else {
                        widget.addClass('clicked');
                        widget.find('a').attr('tabindex', '0');
                        buttons.attr('aria-expanded', 'true');
                    }
                }
                widget.removeClass('hover');
            }
        });

        $('.widget-js').on('mouseleave', (e) => {
            const width = $(window).width();
            if (width >  768) {
                const widget = $(e.currentTarget);
                widget.removeClass('clicked');
                widget.removeClass('hover');
                widget.find('a').attr('tabindex', '-1');
                buttons.attr('aria-expanded', 'false');
            }
        });

        $('.widget-js').on('mouseenter', (e) => {
            const width = $(window).width();
            if (width >  768) {
                const widget = $(e.currentTarget);
                widget.addClass('hover');

                if (widget.hasClass('clicked')) {
                    widget.removeClass('clicked');
                    widget.find('a').attr('tabindex', '-1');
                    buttons.attr('aria-expanded', 'false');
                }
                else {
                    widget.addClass('clicked');
                    widget.find('a').attr('tabindex', '0');
                    buttons.attr('aria-expanded', 'true');
                }
            }
        });
        
        $(window).on("resize" , () => {
            const width = $(window).width();
            const widget = $('.widget');
            const closeButton = widget.find('.widget__close-js');
            const button = widget.find('[role="button"]');
            if (widget.css('visibility') === 'hidden' && width >  768) {
                widget.css('visibility', 'visible');

                closeButton.attr('aria-hidden', 'true');
                button.attr('aria-hidden', 'false');
            } else if (widget.css('visibility') === 'visible' && width <=  768) {
                widget.find('.widget__close-js').css('visibility', 'visible');

                closeButton.attr('aria-hidden', 'false');
                button.attr('aria-hidden', 'true');
            } else if (width >  768) {
                widget.find('.widget__close-js').css('visibility', 'hidden');

                closeButton.attr('aria-hidden', 'true');
                button.attr('aria-hidden', 'false');
            } else {
                return;
            }
        });
    }

    return {
        init: init
    }
})();
`